import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Draw } from 'ol/interaction';
import { Layer, VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import VectorSource from 'ol/source/Vector';
import { Style, Stroke } from 'ol/style';
import { Observable } from 'rxjs';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { TopLevelLayers } from '../menu/view-menu/top-level-layers';
import { AnnotationModel } from '../models/annotation';
import { EndpointsService } from './endpoints.service';
import { MapService } from './map.service';
import olMap from 'ol/Map';
import { ModalConfirmationService } from './modal-confirmation.service';
import { PointsService } from './points.service';
import { ModalControlService } from '../services/modal-control.service';

@Injectable({
  providedIn: 'root'
})
export class AnnotationService {

  map : olMap;
  draw : Draw;

  constructor(private http: HttpClient,
    private endpointService: EndpointsService,
    private mapService: MapService,
    private globalService : GlobalSelectionControlService,
    private modalConfirmationService : ModalConfirmationService,
    private modalService : ModalControlService,
    private pointsService : PointsService) {
      this.map = mapService.getMap('map');
    }

    deleteAnnotationsFromMap() : void{
      this.globalService.annotationLayers.childLayers?.forEach(el => {
        el.hideAll();
        el.layers.forEach(layer => {
          layer.olLayer.setVisible(false);
        }
        )
      });
      this.globalService.annotationLayers.childLayers = [];
    }

  getAnnotation(): Observable<AnnotationModel[]> {
    return this.http.get<AnnotationModel[]>(
      this.endpointService.apiUrlAnnotations,
      this.endpointService.httpOptions
    );
  }

  getAllAnnotations() : Observable<AnnotationModel[]>{
    return this.http.get<AnnotationModel[]>(
      this.endpointService.apiUrlAnnotations + '/list',
      this.endpointService.httpOptions
      )
  }

  saveAnnotation(annotation: AnnotationModel): Observable<any>{
    if (annotation.id == null) {
      return this.http
        .post<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    } else {
      return this.http
        .put<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    }
  }

  async saveAnnotationAsync(annotation: AnnotationModel): Promise<any>{
    if (annotation.id == null) {
      return this.http
        .post<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    } else {
      return this.http
        .put<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    }
  }

  deleteAllAnnotationsAction(): void{
    this.modalConfirmationService.showMesssageConfirmationModal("Delete", "Do you want to delete all annotations?","Yes", "No", () => this.deleteAllAnnotations());
  }

  deleteAllAnnotations() : void {
    this.deleteAnnotationsFromMap();
    this.pointsService.annotations.forEach(el => {
      this.deleteDBAnnotation(el.id).subscribe(res => {
        if(res){
          this.pointsService.annotations.delete(el.id);
        }
        else{
          this.modalService.showMesssageModal('Error', 'An error occured on delete Annotations');
        }
      }, 
      (error) => {
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal("Error", "An error occured on deleting the annotation");
      });
    });
  }

  hideAnnotation(annotation : TopLevelLayers): void{
    let current : AnnotationModel;
    this.pointsService.annotations.forEach(el => {
      if(el.name == annotation.name){
        current = el;
      }
    })
    current.visible = !current.visible;
    this.globalService.annotationLayers.selectChild(annotation);
    this.saveAnnotationAsync(current).then(res => {
      if(!res){
        this.modalService.showMesssageModal('Error', 'An error occured on hiding the annotation');
      }
    },
    (error) => {
      if (error && error.status == 401) {
        this.modalService.showMesssageModal(
          'Error',
          'Default Project is not editable.'
        )
        return;
      }
      this.modalService.showMesssageModal("Error", "An error occured on hiding the annotation");
    });
  }

  deleteAnnotation(name : string): void{
    let current : AnnotationModel;
    this.pointsService.annotations.forEach(el => {
      if(el.name == name){
        current = el;
      }
    })
    this.deleteDBAnnotation(current.id).subscribe(res => {
      if(res){
        this.pointsService.annotations.delete(current.id);
      }
      else{
        this.modalService.showMesssageModal('Error', 'An error occured on delete the annotation');
      }
    },
    (error) => {
      if (error && error.status == 401) {
        this.modalService.showMesssageModal(
          'Error',
          'Default Project is not editable.'
        )
        return;
      }
      this.modalService.showMesssageModal("Error", "An error occured on deleting the annotation");
    });
  }

  private deleteDBAnnotation(id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(
        this.endpointService.apiUrlAnnotations + '/' + id,
        this.endpointService.httpOptions
      );
  }
}
